import React from 'react';
import { notificationType } from './../shared_proptypes';
import StatusIcon from '../StatusIcon';
import NotificationItemDetails from "../NotificationItemDetails";
import { compact } from "underscore";

function BulkOperationNotification({ notification }) {
  let downloadButtonConfig;
  let linkButtonConfig;

  if (notification.downloadUrl) {
    downloadButtonConfig = { url: notification.downloadUrl, label: "Download" };
  }
  if (notification.link && notification.linkButtonLabel) {
    linkButtonConfig = { url: notification.link, label: notification.linkButtonLabel };
  }
  const buttonConfigs = compact([downloadButtonConfig, linkButtonConfig]);

  return (
    <span className="notification-item" data-test-id="notification_template">
      <StatusIcon status={notification.status} />
      <NotificationItemDetails
        orgType={notification.orgType}
        orgName={notification.orgName}
        message={notification.message}
        buttonConfigs={buttonConfigs}/>
    </span>
  );
}

BulkOperationNotification.propTypes = {
  notification: notificationType().isRequired
};

export default BulkOperationNotification;
